import React, { useState, useEffect } from 'react';
import { Line, Bar } from 'react-chartjs-2';
import Sidebar from '../../components/Sidebar';
import { Box, Card, CardContent, Typography, Button, Grid } from '@mui/material';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import axios from "axios";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, Title, Tooltip, Legend);

const BuyerDashboard = () => {
  const user = useAuth();

  const [orders, setOrders] = useState([]);
  const [purchaseHistoryData, setPurchaseHistoryData] = useState({
    labels: [],
    datasets: [],
  });
  const [spendingData, setSpendingData] = useState({
    labels: [],
    datasets: [],
  });
  const [arrivalData, setArrivalData] = useState({
    labels: [],
    datasets: [],
  });
  const navigate = useNavigate();

  const email = user?.email;
  console.log(user);
  useEffect(() => {
    if (email) {
      fetchOrders(email);
    }
  }, [email]);

  useEffect(() => {
    generateChartData();
  }, [orders]);



  
  const fetchOrders = async (email) => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/order/get/email/${email}`
      );
      setOrders(response.data);
    } catch (error) {
      console.error("Error fetching orders:", error.message);
      console.error("Error details:", error.response);  // Check for error details
    }
  };
  
  console.log(email);
  console.log(orders);
  // Transform orders data to generate chart data
  const generateChartData = () => {
    if (!orders || orders.length === 0) return;

    const monthlyPurchases = {};
    const monthlySpending = {};
    const monthlyArrivals = {}; // To track when orders arrive

    orders.forEach(order => {
        if (!order || !order.orderDate || order.totalAmount === undefined || !order.arrivalDate) return;

        const orderMonth = new Date(order.orderDate).toLocaleString('default', { month: 'short' });
        const arrivalMonth = new Date(order.arrivalDate).toLocaleString('default', { month: 'short' }); // For tracking arrivals

        if (!monthlyPurchases[orderMonth]) {
            monthlyPurchases[orderMonth] = 0;
            monthlySpending[orderMonth] = 0;
        }

        if (!monthlyArrivals[arrivalMonth]) {
            monthlyArrivals[arrivalMonth] = 0;
        }

        monthlyPurchases[orderMonth]++;
        monthlySpending[orderMonth] += order.totalAmount;
        monthlyArrivals[arrivalMonth]++; // Track when the orders will arrive
    });

    const labels = Object.keys(monthlyPurchases);
    const purchaseValues = Object.values(monthlyPurchases);
    const spendingValues = Object.values(monthlySpending);
    const arrivalValues = Object.values(monthlyArrivals);

    if (labels.length > 0 && purchaseValues.length > 0 && spendingValues.length > 0) {
        setPurchaseHistoryData({
            labels,
            datasets: [{
                label: 'Purchases',
                data: purchaseValues,
                borderColor: '#4CAF50',
                backgroundColor: '#4CAF50',
            }]
        });

        setSpendingData({
            labels,
            datasets: [{
                label: 'Spending ($)',
                data: spendingValues,
                backgroundColor: '#FF7043',
            }]
        });
    }

    // Optionally, you can add a separate dataset for order arrivals
    setArrivalData({
        labels,
        datasets: [{
            label: 'Arrivals',
            data: arrivalValues,
            borderColor: '#FFEB3B',
            backgroundColor: '#FFC107',
        }]
    });
};
const accountStatus = user?.account_status;

if (accountStatus !== 'active') {
    return (
      <Box className="p-3 min-h-screen dark:bg-gray-900 bg-gray-100" sx={{ marginLeft: { xs: 0, md: '240px' } }}>
        <Sidebar />
        <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
          <CardContent>
            <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
              Subscription Expired
            </Typography>
            <Typography className="mt-2 dark:text-gray-400 text-gray-700">
              Your subscription has expired. To access the dashboard, please renew your subscription from your profile.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2, borderRadius: '8px' }}
              href="/profile"
              className="mt-4 bg-blue-500 hover:bg-blue-600 text-white dark:bg-blue-700 dark:hover:bg-blue-800"
            >
              Go to Profile
            </Button>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <>
      <Sidebar />
      <Box className="p-3 min-h-screen dark:bg-gray-900 bg-gray-100" sx={{ marginLeft: { xs: 0, md: '240px' } }}>
        <Grid container spacing={3}>

          {/* Welcome Card */}
          <Grid item xs={12}>
            <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                  Welcome Back, {user?.name || 'User'}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2, borderRadius: '8px' }}
                  href="/categories/1"
                  className="mt-4 bg-blue-500 hover:bg-blue-600 text-white dark:bg-blue-700 dark:hover:bg-blue-800"
                >
                  Browse Products
                </Button>
              </CardContent>
            </Card>
          </Grid>

     {/* Purchase History Chart */}
<Grid item xs={12} md={6}>
    <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
        <CardContent>
            <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                Purchase History
            </Typography>
            {purchaseHistoryData?.datasets?.length > 0 ? (
                <Line
                    data={purchaseHistoryData}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: {
                                display: true,
                                position: 'top',
                                labels: {
                                    color: 'grey',
                                },
                            },
                        },
                        scales: {
                            x: {
                                ticks: {
                                    color: 'grey',
                                },
                            },
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    stepSize: 1,  // Ensure only integers are shown
                                    color: 'grey',
                                },
                            },
                        },
                    }}
                    className="mt-4"
                />
            ) : (
                <Typography>No data available for Purchase History</Typography>
            )}
        </CardContent>
    </Card>
</Grid>

{/* Spending Chart */}
<Grid item xs={12} md={6}>
    <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
        <CardContent>
            <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                Monthly Spending
            </Typography>
            {spendingData?.datasets?.length > 0 ? (
                <Bar
                    data={spendingData}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: {
                                display: true,
                                position: 'top',
                                labels: {
                                    color: 'grey',
                                },
                            },
                        },
                        scales: {
                            x: {
                                ticks: {
                                    color: 'grey',
                                },
                            },
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    stepSize: 1,  // Ensure only integers are shown
                                    color: 'grey',
                                },
                            },
                        },
                    }}
                    className="mt-4"
                />
            ) : (
                <Typography>No data available for Spending</Typography>
            )}
        </CardContent>
    </Card>
</Grid>

{/* Order Arrival Chart */}
<Grid item xs={12} md={6}>
    <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
        <CardContent>
            <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                Monthly Order Arrivals
            </Typography>
            {arrivalData?.datasets?.length > 0 ? (
                <Line
                    data={arrivalData}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: {
                                display: true,
                                position: 'top',
                                labels: {
                                    color: 'grey',
                                },
                            },
                        },
                        scales: {
                            x: {
                                ticks: {
                                    color: 'grey',
                                },
                            },
                            y: {
                                beginAtZero: true,
                                ticks: {
                                    stepSize: 1,  // Ensure only integers are shown
                                    color: 'grey',
                                },
                            },
                        },
                    }}
                    className="mt-4"
                />
            ) : (
                <Typography>No data available for Order Arrivals</Typography>
            )}
        </CardContent>
    </Card>
</Grid>

          {/* Button to View Purchase History */}
          <Grid item xs={12}>
            <Card className="p-4 rounded-lg shadow-md dark:bg-gray-800 dark:text-white bg-white text-gray-900">
              <CardContent>
                <Typography variant="h6" gutterBottom className="text-lg font-semibold dark:text-gray-100 text-gray-800">
                  Purchase History
                </Typography>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ mt: 2, borderRadius: '8px' }}
                  href="/user/purchase-history"
                  className="mt-4 bg-green-500 hover:bg-green-600 text-white dark:bg-green-700 dark:hover:bg-green-800"
                >
                  View Full Purchase History
                </Button>
              </CardContent>
            </Card>
          </Grid>

        </Grid>
      </Box>
    </>
  );
};

export default BuyerDashboard;

